/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './layout-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../../common/controller/signal-admin-resource-list-state';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {LayoutApiService, LayoutModel} from './layout-api.service';

@Component({
  standalone: false,
  selector: 'adn-layout-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.layouts.layout';
  private readonly localNetworkProfile = inject(LocalNetworkProfile);
  private readonly localUserProfile = inject(LocalUserProfile);
  readonly list = inject(SignalAdminResourceListStateFactory).create<LayoutModel>(
    inject(LayoutApiService),
    {listId: 'fullLayoutList', baseTable: 'layout'},
    inject(DestroyRef)
  );

  showApprovalStatus = false;
  columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'layoutType', label: 'type'},
    {param: '', label: 'components', sortable: false},
    {param: 'layoutCategory', label: 'layoutCategory'}
  ];

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    const isSpecialUser = this.localUserProfile.get('username') === 'adnuntius@adnuntius.com'
      || this.localUserProfile.get('username') === 'broker1@adnuntius.com';
    this.showApprovalStatus = this.localNetworkProfile.isPureMarketplacePlatform() && isSpecialUser;
    if (this.showApprovalStatus) {
      this.columns = [...this.columns, {param: '', label: 'approvalStatus', sortable: false}];
    }
    this.list.load();
  }
}
